(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
   * Engraving Overlay — Collection Grid + Recommendations
   * Shows a fixed default county engraving on product card
   * images across the site: collection/shop grids AND the
   * "Complete the Clann" recommendations carousel.
   *
   * Each product can have its own default county/material.
   * ═══════════════════════════════════════════════════════════ */

  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0827/9172/7443/files/';

  /* ── Product configs ──
   * defaultCounty / defaultMaterial: per-product defaults (capitalised county name)
   * Change these to show a different engraving per product. */
  var PRODUCTS = [
    {
      name: 'bracelet',
      bases: ['/files/7.png', '/files/6.png'],
      defaultCounty: 'Dublin',
      defaultMaterial: 'gold',
      cx: 0.49537037037037035,
      cy: 515 / 1080,
      d:  350 / 1080,
      overlayClass: 'cgo-bracelet',
      reflection: false
    },
    {
      name: 'necklace',
      bases: ['/files/CONN-BLANKGOL.png', '/files/CONN-BLANKSIL.png'],
      defaultCounty: 'Louth',
      defaultMaterial: 'gold',
      cx: 0.5,
      cy: 515 / 1080,
      d:  300 / 1080,
      overlayClass: 'cgo-necklace',
      reflection: true,
      refCx: 540 / 1080,
      refCy: 826 / 1080,
      refOpacity: 0.05
    }
  ];

  /* ── Build overlay URL per product ── */
  function overlayUrl(product) {
    return CDN_BASE + product.defaultCounty + '_' + product.defaultMaterial + '.png';
  }

  /* ── Helpers ── */

  function matchProduct(src) {
    if (!src) return null;
    var clean = src.split('?')[0];
    for (var p = 0; p < PRODUCTS.length; p++) {
      for (var b = 0; b < PRODUCTS[p].bases.length; b++) {
        if (clean.indexOf(PRODUCTS[p].bases[b]) !== -1) return PRODUCTS[p];
      }
    }
    return null;
  }

  /**
   * Compute the actual rendered image area inside an element,
   * accounting for object-fit: contain vs cover.
   * Returns {left, top, width, height} relative to the container.
   */
  function getRenderedImageRect(imgEl, containerEl) {
    var imgRect = imgEl.getBoundingClientRect();
    var conRect = containerEl.getBoundingClientRect();
    var elW = imgRect.width;
    var elH = imgRect.height;
    var natW = imgEl.naturalWidth || elW;
    var natH = imgEl.naturalHeight || elH;

    var objFit = window.getComputedStyle(imgEl).objectFit;

    var renderW, renderH, offsetX, offsetY;

    if (objFit === 'contain') {
      var scale = Math.min(elW / natW, elH / natH);
      renderW = natW * scale;
      renderH = natH * scale;
      offsetX = (elW - renderW) / 2;
      offsetY = (elH - renderH) / 2;
    } else {
      /* cover or fill — image fills the element box */
      renderW = elW;
      renderH = elH;
      offsetX = 0;
      offsetY = 0;
    }

    return {
      left:   (imgRect.left - conRect.left) + offsetX,
      top:    (imgRect.top  - conRect.top)  + offsetY,
      width:  renderW,
      height: renderH
    };
  }

  function positionOverlay(el, imgEl, mediaEl, cx, cy, d) {
    var r = getRenderedImageRect(imgEl, mediaEl);
    if (r.width === 0 || r.height === 0) return;

    var refSize = Math.min(r.width, r.height);
    var size = refSize * d;
    var px = r.left + r.width  * cx;
    var py = r.top  + r.height * cy;

    el.style.width  = size + 'px';
    el.style.height = size + 'px';
    el.style.left   = (px - size / 2) + 'px';
    el.style.top    = (py - size / 2) + 'px';
  }

  /* ── Overlay creation ── */

  function createOverlayEl(className, isNecklace) {
    var wrap = document.createElement('div');
    wrap.className = 'collection-engraving-overlay ' + className;
    wrap.style.cssText =
      'position:absolute;pointer-events:none;z-index:6;display:none;' +
      (isNecklace ? 'border-radius:50%;overflow:hidden;' : '');
    var img = document.createElement('img');
    img.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;';
    img.alt = '';
    img.draggable = false;
    img.decoding = 'sync';
    wrap.appendChild(img);
    return wrap;
  }

  function createReflectionEl(className, opacity) {
    var wrap = document.createElement('div');
    wrap.className = 'collection-engraving-overlay ' + className + '-refl';
    wrap.style.cssText =
      'position:absolute;pointer-events:none;z-index:5;display:none;' +
      'border-radius:50%;overflow:hidden;opacity:' + opacity + ';transform:scaleY(-1);';
    var img = document.createElement('img');
    img.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;';
    img.alt = '';
    img.draggable = false;
    img.decoding = 'sync';
    wrap.appendChild(img);
    return wrap;
  }

  /* ── Find the correct overlay container for an image ── */

  function findContainer(imgEl) {
    /* Collection grid cards */
    var media = imgEl.closest('.gc-product-card__media');
    if (media) return media;

    /* Recommendations carousel cards */
    var imageLink = imgEl.closest('.gc-clann-card__image-link');
    if (imageLink) {
      /* Ensure the container can hold absolute-positioned children */
      if (window.getComputedStyle(imageLink).position === 'static') {
        imageLink.style.position = 'relative';
      }
      return imageLink;
    }

    return null;
  }

  /* ── Process a single product card image ── */

  function processImage(imgEl) {
    var src = imgEl.currentSrc || imgEl.src || '';
    var product = matchProduct(src);
    if (!product) return;

    var mediaEl = findContainer(imgEl);
    if (!mediaEl) return;
    if (mediaEl.querySelector('.' + product.overlayClass)) return;

    var url = overlayUrl(product);

    /* Main overlay */
    var overlay = createOverlayEl(product.overlayClass, product.name === 'necklace');
    var overlayImg = overlay.querySelector('img');
    mediaEl.appendChild(overlay);

    overlayImg.onload = function () {
      overlay.style.display = 'block';
      positionOverlay(overlay, imgEl, mediaEl, product.cx, product.cy, product.d);
    };
    overlayImg.src = url;

    /* Reflection (necklace only) */
    if (product.reflection) {
      var refl = createReflectionEl(product.overlayClass, product.refOpacity);
      var reflImg = refl.querySelector('img');
      mediaEl.appendChild(refl);

      reflImg.onload = function () {
        refl.style.display = 'block';
        positionOverlay(refl, imgEl, mediaEl, product.refCx, product.refCy, product.d);
      };
      reflImg.src = url;
    }
  }

  /* ── Scan & observe ── */

  var IMG_SELECTORS = '.gc-product-card__image, .gc-clann-card__image';

  function scanAll() {
    document.querySelectorAll(IMG_SELECTORS).forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        processImage(img);
      } else {
        img.addEventListener('load', function handler() {
          processImage(img);
          img.removeEventListener('load', handler);
        });
      }
    });
  }

  function repositionAll() {
    PRODUCTS.forEach(function (product) {
      document.querySelectorAll('.' + product.overlayClass).forEach(function (overlay) {
        var mediaEl = overlay.parentElement;
        if (!mediaEl) return;
        var imgEl = mediaEl.querySelector('.gc-product-card__image') ||
                    mediaEl.querySelector('.gc-clann-card__image');
        if (!imgEl) return;
        positionOverlay(overlay, imgEl, mediaEl, product.cx, product.cy, product.d);
      });
      if (product.reflection) {
        document.querySelectorAll('.' + product.overlayClass + '-refl').forEach(function (refl) {
          var mediaEl = refl.parentElement;
          if (!mediaEl) return;
          var imgEl = mediaEl.querySelector('.gc-product-card__image') ||
                      mediaEl.querySelector('.gc-clann-card__image');
          if (!imgEl) return;
          positionOverlay(refl, imgEl, mediaEl, product.refCx, product.refCy, product.d);
        });
      }
    });
  }

  /* ── Inject hover-zoom CSS to match product card image scale ── */
  function injectHoverCSS() {
    var style = document.createElement('style');
    style.textContent =
      '@media screen and (min-width: 990px) {' +
        '.gc-product-card:hover .collection-engraving-overlay {' +
          'transform: scale(1.03);' +
          'transition: transform var(--duration-long, 0.5s) ease;' +
        '}' +
        '.gc-product-card:hover .collection-engraving-overlay[class*="-refl"] {' +
          'transform: scaleY(-1) scale(1.03);' +
          'transition: transform var(--duration-long, 0.5s) ease;' +
        '}' +
      '}' +
      '.collection-engraving-overlay {' +
        'transition: transform var(--duration-long, 0.5s) ease;' +
      '}';
    document.head.appendChild(style);
  }

  function init() {
    injectHoverCSS();
    scanAll();

    /* Re-scan when new cards are added (infinite scroll, AJAX filters, carousel) */
    var root = document.querySelector('main') || document.body;
    var observer = new MutationObserver(function () {
      scanAll();
    });
    observer.observe(root, { childList: true, subtree: true });

    /* Reposition on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(repositionAll, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();